module.exports = __webpack_public_path__ + "static/media/tourist_arrival_ph_trend_regional_wide.addb2cfe.png";